import { render, staticRenderFns } from "./jobList.vue?vue&type=template&id=02d90c01&scoped=true"
import script from "./jobList.vue?vue&type=script&lang=js"
export * from "./jobList.vue?vue&type=script&lang=js"
import style0 from "./jobList.vue?vue&type=style&index=0&id=02d90c01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d90c01",
  null
  
)

export default component.exports